import clsx from 'clsx'
import React, {useContext} from 'react'
import {Link, useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import {faShoppingBasket} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import CreateAssessmentForm from 'components/quiz/content/create-assessment/form'

import Box from '@mui/material/Box'

import CartPopper from './cart-popper'

import {TeacherContext} from 'teacher/context'



const useStyles = makeStyles(cartStyles)

export default function Cart() {

  const classes = useStyles()
  const history = useHistory()
  const context = useContext(TeacherContext)
  const {quizQuestionBankCart: cart, quizQuestionBankCartEl, updateState} = context
  const count = cart.length
  const hasQuestions = count > 0

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    hasQuestions && updateState({quizQuestionBankCartEl: {$apply: el => el ? null : event.currentTarget}})
  }

  const isCartOpen = Boolean(quizQuestionBankCartEl)

  return (
    <Box className={classes.root}>
      <CartPopper>
        <Box className={clsx(classes.button, {hasQuestions})} onClick={handleClick}>
          <FontAwesomeIcon icon={faShoppingBasket} />
          <span className={classes.count}>{count}</span>
        </Box>
      </CartPopper>
      <CreateAssessmentForm context={context} useCart />
    </Box>
  )
}

function cartStyles() {
  return {
    root: {
      marginTop: 16,
      fontSize: '11pt',
      '& svg': {
        marginTop: 2,
        marginRight: 8
      }
    },
    count: {
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#f4f4f4',
      padding: '4px 10px',
      borderRadius: 8,
      color: '#cbc4c4',
      "&.hasQuestions": {
        color: '#fff',
        cursor: 'pointer',
        backgroundColor: '#76c278',
      }
    }
  }
}

